import { TimeRange } from '../components/TimeWindowSelect'

export type ItemModalProps = {
  oid: string
  cid: string
  timeRange: TimeRange
  onClose?: () => void
}

export enum ItemType {
  Metrics = 1,
  InstanceLogs = 2,
  SlowQuery = 3,
  Download = 4
}
